<template>
    <div class='blog'>
        <div class="container header">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <router-link :to="{name: 'blog'}">
                        <h1 class="title is-size-1 has-text-black has-text-weight-normal">Taskflex<span class="has-text-primary">Blog</span></h1>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <featured-post></featured-post>

                    <br>

                    <tag-bar></tag-bar>

                    <br>

                    <category-section :category-id="2"></category-section>

                    <category-section :category-id="3"></category-section>

                    <category-section :category-id="4"></category-section>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .blog {
        background: $background-blueish;

        .header {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            margin-bottom: 12px;

            .column {
                padding-top: 20px;
            }
        }
    }
</style>

<script>
    import FeaturedPost from '@/taskflex/blog/components/FeaturedPost';
    import CategorySection from '@/taskflex/blog/components/CategorySection';
    import TagBar from '@/taskflex/blog/components/TagBar';

    export default {

        components: {
            CategorySection,
            FeaturedPost,
            TagBar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/pages/Landing.vue